/* eslint-disable no-unused-vars*/
import React, { Fragment } from 'react';
import { useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { Card } from 'antd';
import CreateAutomaticallyLimitnumber from 'components/AutomaticallyLimitnumber/create.automaticallyLimitnumber';
import { HasAccess } from '@permify/react-role';
import { ErrorPage404 } from 'common/Error/error.common';

const AutomaticallyLimitnumberCreatePage = () => {
   const location = useLocation();
   const locationSplit = location?.pathname.split('/');
   let id = null;
   if (location?.pathname.includes('edit')) {
      id = Number(locationSplit[4]);
   }

   return (
      <Fragment>
         <Helmet>
            <title>{id ? 'แก้ไขข้อมูลเลขอั้นอัตโนมัติ' : 'สร้างข้อมูลเลขอั้นอัตโนมัติ' }</title>
         </Helmet>
         <HasAccess
            roles={['Owner']}
            permissions={['period-create']}
            renderAuthFailed={<ErrorPage404 />}
         >
            <Card title={`${id ? 'แก้ไขข้อมูลเลขอั้นอัตโนมัติ' : 'สร้างข้อมูลเลขอั้นอัตโนมัติ' }`}>
               <CreateAutomaticallyLimitnumber id={Number(id)}/>
            </Card>
         </HasAccess>
      </Fragment>
   );
};

export default AutomaticallyLimitnumberCreatePage;
